import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchDashboard, fetchIndicatorDate, fetchStaffDashboardCountData, fetchStaffDashboardRecentActivity } from "../../../service/api";


export const getDashboard = createAsyncThunk(
    "staffDashboard/getAll",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchDashboard(params)
            console.log("stafff dashboard ", response)
            return response.data
        } catch (error) {
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)


export const getDateIndicator = createAsyncThunk(
    "dashboard/getIndicator",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchIndicatorDate(params);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const getStaffDashboardCountData = createAsyncThunk(
    "dashboard/getStaffCount",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchStaffDashboardCountData(params);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);


export const getStaffDashboardRecentActivity = createAsyncThunk(
    "dashboard/getStaffActivity",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchStaffDashboardRecentActivity(params);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);


const dashboardSlice = createSlice({
    name: "staffDashboards",
    initialState: {
        dashboardData: {},
        permissionMap: [],
        indicatorDate: [],
        staffRecentActivity: [],
        staffCountData: {},
        isLoading: false,
        indicatorPending: false,
        actionLoader: false,
        error: null,

    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getDashboard.pending, (state) => {
                state.isLoading = true,
                    state.error = null
            })
            .addCase(getDashboard.fulfilled, (state, action) => {
                state.isLoading = false;
                state.dashboardData = action.payload.data;
                state.permissionMap = (action.payload.data?.accessModules || []).reduce(
                    (acc, module) => {
                        acc[module.moduleName.toLowerCase()] = module.permissions;
                        return acc;
                    },
                    {}
                );
            })
            .addCase(getDashboard.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload
            })

            .addCase(getDateIndicator.pending, (state) => { state.indicatorPending = true; state.error = null; })
            .addCase(getDateIndicator.fulfilled, (state, action) => { state.indicatorPending = false; state.indicatorDate = action.payload.data; })
            .addCase(getDateIndicator.rejected, (state, action) => { state.indicatorPending = false; state.error = action.payload; })

            .addCase(getStaffDashboardCountData.pending, (state) => { state.dashboardLoading = true; state.error = null; })
            .addCase(getStaffDashboardCountData.fulfilled, (state, action) => { state.dashboardLoading = false; state.staffCountData = action.payload.data; })
            .addCase(getStaffDashboardCountData.rejected, (state, action) => { state.dashboardLoading = false; state.error = action.payload; })

            .addCase(getStaffDashboardRecentActivity.pending, (state) => { state.dashboardLoading = true; state.error = null; })
            .addCase(getStaffDashboardRecentActivity.fulfilled, (state, action) => { state.dashboardLoading = false; state.staffRecentActivity = action.payload.data; })
            .addCase(getStaffDashboardRecentActivity.rejected, (state, action) => { state.dashboardLoading = false; state.error = action.payload; })

    }
})
export default dashboardSlice.reducer;